import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Input from '../Input/Input'
import Label from '../Label/Label'
import InputIcon from '../InputIcon/InputIcon'
import PasswordStrength from '../PasswordStrength/PasswordStrength'
import successIcon from '../../../assets/images/icon/check-small.svg'
import errorIcon from '../../../assets/images/icon/error-small.svg'

export const renderLabel = (text) => {
  if (!text) return text;

  const parts = text.split(/(\b[A-Z]{2,}\b)/);

  return parts.map((part, i) => {
    const isUppercase = /^[A-Z]{2,}$/.test(part);
    return (
      <span
        key={i}
        style={{
          fontFamily: isUppercase ? "Montserrat-Bold" : "Montserrat",
          fontWeight: isUppercase ? "bold" : "400",
        }}
      >
        {part}
      </span>
    );
  });
};

const Row = styled.div`
  position: relative;
  margin-bottom: 35px;
`

export const Error = styled.span`
  display: inline-block;
  position: absolute;
  top: 55px;
  left: 10px;
  color: #da4725;
  font-size: 12px;
  font-family: Montserrat;
`

const FieldStatus = styled.span`
  display: block;
  position: absolute;
  top: 35px;
  width: 15px;
  height: 15px;
  right: -25px;
  background: url(${props =>
      props.status === 'error' ? errorIcon : successIcon})
    no-repeat 50%;
`
FieldStatus.propTypes = {
  status: PropTypes.string
}
FieldStatus.defaultProps = {
  status: 'success'
}

const ContentInput = ({
  autoComplete = '',
  placeholder = '',
  iconSrc,
  id,
  passwordStrength = '',
  strongPasswordMsg = '',
  weakPasswordMsg = '',
  label,
  type,
  value,
  error = '',
  status = '',
  minLength,
  maxLength,
  handleChange,
  handleBlur,
  handleFocus,
  backgroundColor,
  autoFocus,
  readonly,
  rowStyle,
	inputStyle
}) => (
  <Row style={{ opacity: readonly ? 0.5 : 1, ...rowStyle }}>
    <Label htmlFor={id} style={{ paddingLeft: '0px' }}>{renderLabel(label)}</Label>
    <Input
      autoComplete={autoComplete}
      readOnly={readonly}
      placeholder={placeholder}
      style={{ backgroundColor, ...inputStyle }}
      type={type}
      id={id}
      name={id}
      value={value}
      minLength={minLength}
      maxLength={maxLength}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      autoFocus={autoFocus}
    />
    {iconSrc && <InputIcon url={iconSrc} />}
    {status && <FieldStatus status={status} />}
    {!passwordStrength && <Error>{error}</Error>}
    {passwordStrength && !error && (
      <PasswordStrength
        strength={passwordStrength}
        strongPasswordMsg={strongPasswordMsg}
        weakPasswordMsg={weakPasswordMsg}
      />
    )}
  </Row>
)

ContentInput.propTypes = {
  iconSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  id: PropTypes.string.isRequired,
  passwordStrength: PropTypes.string,
  strongPasswordMsg: PropTypes.string,
  weakPasswordMsg: PropTypes.string,
  type: PropTypes.string.isRequired,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxLength: PropTypes.number.isRequired,
  minLength: PropTypes.number,
  status: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func,
  handleFocus: PropTypes.func,
  label: PropTypes.string,
  backgroundColor: PropTypes.string,
  autoFocus: PropTypes.bool,
  rowStyle: PropTypes.object,
	inputStyle: PropTypes.object
}

ContentInput.defaultProps = {
  iconSrc: '',
  passwordStrength: '',
  strongPasswordMsg: '',
  weakPasswordMsg: '',
  error: '',
  value: '',
  status: '',
  handleBlur: () => {},
  handleFocus: () => {},
  label: '',
  backgroundColor: '',
  autoFocus: false,
  rowStyle: {},
	inputStyle: {},
  readonly: false,
  minLength: 0
}

export default ContentInput
